<template>
  <b-form @submit="submit" class="item-editor-form">
    <tabs id="tabs-form">
      <tab-pane id="tab-general" active>
        <b-icon slot="title" icon="gear" v-b-tooltip.hover.top="$t('display_groups.general_settings')" scale="1.1"
          aria-hidden="true" />

        <b-form-group id="input-group-name" :label="$t('device_groups.name')" :label-for="'input-name'">
          <b-form-input id="input-name" v-model="item.name" :disabled="disabledFields" required />
        </b-form-group>

        <b-form-group id="input-group-description" :label="$t('device_groups.description')"
          :label-for="'textarea-description'">
          <b-form-textarea id="textarea-description" v-model="item.description"
            :disabled="disabledFields"></b-form-textarea>
        </b-form-group>
        <FormButtons class="formbuttons" @submit="submit"
          :submit="action !== '' && $UIPrivilegeUpdate('devices', 'ssedisplay_groups')" :reset="false"
          :remove="action === 'edit' && $UIPrivilegeDelete('devices', 'ssedisplay_groups')" @remove="remove"
          :itemid="itemName" :modalid="'deviceGroupModal'" :disableSubmit="loading || !isValidForm"
          :disableRemove="loading || disabledFields" />
        <RequestInfo type="save" :ok="OK" :error="ERROR" :loader="loading" />
      </tab-pane>
      <tab-pane v-if="$UIPrivilegeUpdate('devices', 'ssedisplay_groups')" id="tab-group-members">
        <b-icon slot="title" icon="display" v-b-tooltip.hover.top="$t('display_groups.displays_in_group')"
          scale="1.1" />
        <DeviceSelectForm :devices="item.devices" v-on:updateDevices="updateDevices" :disabledFields="disabledFields">
        </DeviceSelectForm>
        <RequestInfo :type="infoType" :ok="!error && showRequestResult" :error="error && showRequestResult"
          :loader="loading" :additionalErrorMsg="responseError" />
        <FormButtons @submit="submit" :submit="action !== '' && $UIPrivilegeUpdate('devices', 'ssedisplay_groups')"
          :reset="false" :remove="action === 'edit' && $UIPrivilegeDelete('devices', 'ssedisplay_groups')
            " @remove="remove" :itemid="itemName" :modalid="'deviceGroupModal'" :disableSubmit="loading || !saveEnabled"
          :disableRemove="loading || disabledFields" />
      </tab-pane>
      <tab-pane v-if="$UIPrivilegeUpdate('devices', 'ssedisplay_groups')" id="display-group-members">
        <b-icon slot="title" icon="wrench" v-b-tooltip.hover.top="$t('display_groups.display_group_actions')"
          scale="1.1" />
        <DisplayGroupActions :key="item.id" :item="item" :devices="item.devices">
        </DisplayGroupActions>
      </tab-pane>
    </tabs>
    <div></div>
    <p></p>
  </b-form>
</template>
  <script>
  import DeviceSelectForm from '@/components/Devices/Device/DeviceSelectForm'
  import DisplayGroupActions from '../Devices/Device/DisplayGroupActions.vue';
  import FormButtons from '@/components/Misc/FormButtons'

  export default {
    components: {
      DeviceSelectForm,
      DisplayGroupActions,
      FormButtons
    },
    props: {
      item: {
        default() {
          return {
            id: null,
            name: '',
            description: '',
            devices: [],
          }
        },
        require: false,
      },
      action: { default: 'new' },
    },
    data() {
      return {
        itemName: '', // original item.name
        showRequestResult: false,
        error: false,
        loading: false,
        infoType: 'save',
        disabledFields: false,
        saveEnabled: false,
        responseError: null,
        OK: false,
        ERROR: false,
      }

    },
    created() {
      this.itemName = this.item.name
    },
    computed: {
     isValidForm() {
       if (this.item?.name) 
       return this.item.name.length > 0
       else 
       return false
     },
    },
    watch: {
      'item.id': function () {
        this.showRequestResult = false
        this.error = false
        this.loading = false
        this.disabledFields = false
        this.infoType = 'save'
      },
      loading: function (val) {
        this.showRequestResult = !val
      },
      item: function (item) {
        this.itemName = item.name
      },
    },
    methods: {
      getFormData() {
        var data = {};
        data.displayId = this.item.id;
        data.settings = this.form;
        return data;
      },
      updateAndEmitItemName(newItemName) {
        this.itemName = newItemName
        this.$emit('itemName', this.itemName)
      },
      updateDevices(newDevices) {
        this.item.devices = newDevices
        this.saveEnabled = true;
      },
      submit(event) {
        if (event) 
        event.preventDefault();
        this.prepareRequest();

        this.item.devices.forEach((item) => {
          delete item.label;
          delete item.id;
        });

        if (this.action === 'new') {
          this.handleNew();
        } else if (this.action === 'edit') {
          this.handleEdit();
        }
      },

      prepareRequest() {
        this.responseError = null;
        this.error = false;
        this.infoType = 'save';
        this.loading = true;
      },

      handleNew() {
        this.$store
          .dispatch('deviceGroup/addDeviceGroup', this.item)
          .then((response) => this.handleResponse(response))
          .catch((error) => this.handleError(error))
          .finally(this.finallyHandler);
      },

      handleEdit() {
        this.$store
          .dispatch('deviceGroup/updateDeviceGroup', this.item)
          .then((response) => {
            this.handleResponse(response);
            if (!this.error) {
              this.updateAndEmitItemName(this.item.name);
              this.saveEnabled = false;
            }
          })
          .catch((error) => this.handleError(error))
          .finally(this.finallyHandler);
      },

      handleResponse(response) {
        const responseCodeHeader = response.status;
        if (responseCodeHeader >= 200 && responseCodeHeader < 300) {
          this.OK = true;
          this.error = false;
        } else {
          this.OK = false;
          this.error = true;
        }
      },

      handleError(error) {
        if (error?.response) {
          const statusCode = error.response?.status;
          const errorMsg = error.response?.data?.message;

          switch (statusCode) {
            case 409:
              this.responseError = this.$t(
                this.action === 'new' ? 'response.object_name_already_exists' : 'response.conflict'
              );
              console.error(errorMsg);
              break;
            case 404:
              this.responseError = this.$t('response.no_object_id');
              console.error(errorMsg);
              break;
            case 400:
              this.responseError = this.$t('response.invalid_entity');
              console.error(errorMsg);
              break;
            default:
              this.responseError = statusCode;
              console.error(errorMsg);
              break;
          }
        } else {
          this.responseError = this.$t('response.server_error');
        }
        this.error = true;
      },

      finallyHandler() {
        setTimeout(() => {
          this.loading = false;
        }, 300);
      },
      remove() {
        this.error = false
        this.infoType = 'delete'
        this.loading = true

        this.$store
          .dispatch('deviceGroup/removeDeviceGroup', this.item.id)
          .then((response) => {
            const responseCodeHeader = response.status
            if (responseCodeHeader >= 200 && responseCodeHeader < 300) {
              this.error = false
            } else {
              this.error = true
            }
          })
          .catch((error) => {
            if (error?.response) {
              const statusCode = error.response?.status
              const errorMsg = error.response?.data?.message
              if (statusCode === 404) {
                this.responseError = this.$t('response.no_object_id')
                console.error(errorMsg)
              } else {
                this.responseError = statusCode
                console.error(errorMsg)
              }
            } else {
              this.responseError = this.$t('response.server_error')
            }
            this.error = true
          })
          .finally(this.finallyHandler);
        this.item.name = ''
        this.item.description = ''
        this.item.devices = []
        // this.action = ''
        this.disabledFields = true
      },
    },
  }
</script>

  
